const UserTypes = {
  GET_USER_LIST_REQUEST: 'GET_USER_LIST_REQUEST',
  GET_USER_LIST_SUCCESS: 'GET_USER_LIST_SUCCESS',
  GET_USER_LIST_ERROR: 'GET_USER_LIST_ERROR',

  ADD_USER_REQUEST: 'ADD_USER_REQUEST',
  ADD_USER_SUCCESS: 'ADD_USER_SUCCESS',
  ADD_USER_ERROR: 'ADD_USER_ERROR',

  GET_USER_ITEM_REQUEST: 'GET_USER_ITEM_REQUEST',
  GET_USER_ITEM_SUCCESS: 'GET_USER_ITEM_SUCCESS',
  GET_USER_ITEM_ERROR: 'GET_USER_ITEM_ERROR',

  UPDATE_USER_REQUEST: 'UPDATE_USER_REQUEST',
  UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
  UPDATE_USER_ERROR: 'UPDATE_USER_ERROR',

  DELETE_USER_REQUEST: 'DELETE_USER_REQUEST',
  DELETE_USER_SUCCESS: 'DELETE_USER_SUCCESS',
  DELETE_USER_ERROR: 'DELETE_USER_ERROR',

  RESEND_ACTIVATION_USER_REQUEST: 'RESEND_ACTIVATION_USER_REQUEST',
  RESEND_ACTIVATION_USER_SUCCESS: 'RESEND_ACTIVATION_USER_SUCCESS',
  RESEND_ACTIVATION_USER_ERROR: 'RESEND_ACTIVATION_USER_ERROR',

  GET_USER_ACTIVE_REQUEST: 'GET_USER_ACTIVE_REQUEST',
  GET_USER_ACTIVE_SUCCESS: 'GET_USER_ACTIVE_SUCCESS',
  GET_USER_ACTIVE_ERROR: 'GET_USER_ACTIVE_ERROR',

  UPDATE_USER_QUERY_PARAMS: 'UPDATE_USER_QUERY_PARAMS'
};

export default UserTypes;
